export class ProductSize {
    ID?: number;
    Name?: string;
}

export default ProductSize;